import ScrollLock from "./ScrollLock";
export default ScrollLock;
